<template lang="html">
  <div class="card-row card-row-show" :class="{ rowdisabled: disabled }">
    <div class="card-header-col card-col w50">
      <Checkbox v-if="disabled" disabled v-model="selected"/>
      <Checkbox v-else v-model="selected" @change="onChange"/>
    </div>
    <div class="card-row-col card-col w150">
      <span class="row-text">
        {{payment.order_number}}
      </span>
    </div>
    <div class="card-row-col card-col w150">
      <span class="row-text">
        {{ payment.delivered_at | moment("DD MMM YYYY")}}
      </span>
    </div>
    <div class="card-row-col card-col w200">
      <Popover popper-class="popover-medium" placement="bottom-end" v-model="showRoutes">
        <div class="popover-primary">
          <div class="popover-primary-header">
            <h3>Destination</h3>
            <span class="remove-icon" @click="showRoutes=false">
              <svgicon name="cancel" width="10" height="10" :original="true" />
            </span>
          </div>
          <div class="popover-primary-body">
            <div v-for="(consignee, index) in getConsigneeList"
              class="invoice-consignee-label"
              :key="index">
              <span class="invoice-consignee-name">
                {{consignee.name}}
              </span>
              <span>-</span>
              <span class="invoice-consignee-name consignee-lr">
                {{consignee.city}}
              </span>
            </div>
          </div>
        </div>
        <div class="row-text" slot="reference">
          {{getDepotCity(payment.depot_id)}}
          <span v-if="getConsigneeList.length">
            - {{getConsigneeList[0].city}}
          </span>
          <span v-if="getConsigneeList.length > 1">
            + {{getConsigneeList.length - 1}}
          </span>
        </div>
      </Popover>
    </div>
    <div class="card-row-col card-col w200">
      <span class="row-text">
        <Ellipsis :text="payment.vehicle_type.name" :length="15"/>
        <!-- {{payment.vehicle_type.name}} -->
      </span>
    </div>
    <div class="card-row-col card-col invoice-payment-actions">
      <div class="action" v-if="isOpenOrder">
         <span v-if="isOpenOrder &&
          (!payment.open_freight_charge || !payment.open_freight_charge.freight_charge ||
            payment.open_freight_charge.freight_charge === 0  )" class="lrnumber-pending">
              Freight rate missing
          </span>
      </div>
      <div class="action" v-if="payment.approval_status !== utilizationStatus.APPROVED">
         <span class="lrnumber-pending">
              Pending Utilisation check
          </span>
      </div>
      <div class="action" v-if="combinePrimarySecondary">
         <span class="lrnumber-pending">
              {{combinePrimarySecondary}}
          </span>
      </div>
      <div class="action">
        <Popover popper-class="popover-auto" placement="bottom-end" v-model="lrNumber">
          <div class="popover-primary">
            <div class="popover-primary-header">
              <h3>LR Number</h3>
              <span class="remove-icon" @click="lrNumber=false">
                <svgicon name="cancel" width="10" height="10" :original="true" />
              </span>
            </div>
            <div class="popover-primary-body" v-for="(consignee, index) in consigneeList"
              :key="index">
              <div class="physical-copy-container">
                <div class="inlineblock_attachment w200">
                  <span>{{consignee.name}}</span>
                  <div class="lrnumber_list" v-for="(lrNumber, index) in consignee.lr_numbers"
                    :key="index">
                    <ul>
                      <li>{{lrNumber}}</li>
                    </ul>
                  </div>
                </div>
                <div class="inlineblock_attachment">
                  <span class="paddingspan">
                    <Attachments
                      :attachments='attachments[index]'
                      v-on:addAttachments='addAttachments(consignee, index, $event)'
                      v-on:removeAttachments="removeAttachments(consignee, index, $event)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="popfooter">
              <Checkbox v-model="payment.documents_available" @change="physicalCopyChange"/>
              <span>Physical LR available</span>
            </div>
          </div>
          <div slot="reference" @click="getLrAttachments">
            <svgicon name="lr" width="10" height="10" :original="true" />
            <span v-if="showLRNumber">LR NUMBER</span>
            <span v-else class="lrnumber-pending">LR NUMBER</span>
          </div>
        </Popover>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import AppConstant from '@/constants/app';
import Attachments from '@common/components/Attachments';
import { groupBy } from 'lodash';
import { movementMapLower, utilizationStatus } from 'pando-constants';

export default {
  props: ['payment', 'depots', 'selectedAll', 'delivery_type', 'state', 'specialPickupGate',
    'movement'],
  data() {
    return {
      selected: false,
      lrNumber: false,
      showRoutes: false,
      showPopover: false,
      attachments: [],
      consigneeList: [],
      tempAttachments: [],
      attachmentsAvailable: true,
      utilizationStatus,
      combinePrimarySecondary: '',
      movementMapLower,
    };
  },
  components: {
    Attachments,
  },
  methods: {
    onChange(status) {
      this.$emit('select', this.payment, status);
    },
    getDepotCity(depotId) {
      const depot = this.depots.find(depot => depot.id == depotId);
      let city = depot && depot.city;
      if (!city) {
        // for vendor and return movement
        city = this.payment.depot && this.payment.depot.city;
      }
      return city || '';
    },
    async physicalCopyChange(status) {
      try {
        if (!status && this.selected) {
          this.onChange(false);
          this.selected = false;
        }
        await this.$store.dispatch('payment/updatephysical', {
          id: this.payment.id,
          received: status,
        });
        this.$success({ message: `Physical copy status updated for ${this.payment.order.order_number}` });
      } catch (err) {
        this.$error({ message: 'Unable to update physical copy status' });
      }
    },
    async addAttachments(currentConsignee, index, file) {
      const formData = new FormData();
      formData.append('attachment', file.raw);
      const result = await this.$store.dispatch('payment/uploadDocument', formData);
      if (result) {
        file.id = result.id;
        this.attachments[index].push(file);
        this.$set(this.attachments, index, this.attachments[index]);
        this.tempAttachments.push(file);
        const data = [{
          destination_id: currentConsignee.id,
          lr_attachment_ids: [result.id],
          source_location_id: currentConsignee.source_location_id,
        }];
        const response = await this.$store.dispatch('payment/saveLorryReceipt', { orderId: this.payment.order_number, data });
        if (response.data) {
          const consignee = response.data.consignees.find(consignee => consignee.id === currentConsignee.id);
          this.$store.commit('payment/SET_ATTACHMENTS_IDS', { payment_id: this.payment.id, consignee_id: consignee.id, lr_attachment_ids: consignee.lr_attachment_ids });
        }
      } else {
        this.$error({ message: this.$getErr('UPLOAD_FAILS') });
      }
    },
    async removeAttachments(consignee, index, file) {
      const data = {
        indent_id: this.payment.order_number,
        consignee_id: consignee.id,
        file_id: file.id,
      };
      const result = await this.$store.dispatch('payment/removeAttachment', { data });
      this.$set(this.attachments, index, this.attachments[index].filter(attachment => attachment.id !== file.id));
      consignee.lr_attachment_ids = consignee.lr_attachment_ids.filter(id => id !== file.id);
      if (!consignee.lr_attachment_ids.length && this.selected) {
        this.onChange(false);
        this.selected = false;
      }
      this.$store.commit('payment/SET_ATTACHMENTS_IDS', { payment_id: this.payment.id, consignee_id: consignee.id, lr_attachment_ids: consignee.lr_attachment_ids });
    },
    async getLrAttachments() {
      const result = await this.$store.dispatch('payment/getLrAttachments', { orderId: this.payment.order_number });
      if (result.data) {
        this.consigneeList = result.data.consignees.map((consignee) => {
          const cons = this.payment.consignees.find(paymentConsignee => paymentConsignee.id === consignee.id);
          return {
            id: cons.id,
            name: cons.name,
            lr_numbers: cons.lr_number,
            lr_attachment_ids: cons.lr_attachment_ids,
            source_location_id: cons.source_location_id,
          };
        });
        this.attachments = result.data.consignees.map(consignee =>
          consignee.lr_details.map(attachment => ({ name: attachment.name, url: attachment.attachment_url, id: attachment.id })),
        );
      }
    },
  },

  watch: {
    selectedAll(newVal) {
      this.selected = newVal;
    },
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    getConsigneeList() {
      return this.payment.consignees.map(consignee => ({ id: consignee.id, name: consignee.name, city: consignee.city }));
    },
    showLRNumber() {
      return this.payment.documents_available;
      // return this.payment.documents_available && (this.$hasFeature('lr_attachment_required') ? this.attachmentsAvailable : true);
    },
    disabled() {
      let forcedisable = false;
      if (this.payment.approval_status !== this.utilizationStatus.APPROVED) {
        forcedisable = true;
      }

      if (this.delivery_type && this.delivery_type !== this.payment.delivery_type) {
        forcedisable = true;
      }

      if (this.state && this.state !== this.payment.depot_id) {
        forcedisable = true;
      }
      if (this.specialPickupGate) {
        if (this.payment.special_pickup_gate !== null) {
          if (this.specialPickupGate === '-') {
            forcedisable = true;
          } else if (this.specialPickupGate !== this.payment.special_pickup_gate._id) {
            forcedisable = true;
          }
        } else if (this.specialPickupGate !== '-') {
          forcedisable = true;
        }
      }

      if (AppConstant.OrderType.OPEN === this.payment.order_type) {
        if (
          !this.payment.open_freight_charge ||
            !this.payment.open_freight_charge.freight_charge ||
            !this.payment.open_freight_charge.freight_charge === 0
        ) {
          return true;
        }
      }

      const consignees = groupBy(this.payment.consignees, 'id');
      this.attachmentsAvailable = Object.keys(consignees).every(key => consignees[key].some(consignee => consignee.lr_attachment_ids.length));
      // if (this.$hasFeature('lr_attachment_required') && !this.attachmentsAvailable) {
      //   forcedisable = true;
      // }

      this.combinePrimarySecondary = '';
      if (this.currentClientConfig.payment_settings &&
        this.currentClientConfig.payment_settings.max_indents_for_invoice) {
        if (this.movement && this.movement !== this.payment.movement) {
          this.combinePrimarySecondary = 'Cannot combine indents from multiple movements';
          forcedisable = true;
        }
        const count = this.currentClientConfig.payment_settings.max_indents_for_invoice[this.movementMapLower[this.movement]];
        const { $store: { payments: { selected } } } = this;
        if (count <= selected.length && !this.selected) {
          let errorMsg;
          if (count === 1) {
            errorMsg = `Cant select more than ${count} indent`;
          }
          this.combinePrimarySecondary = errorMsg;
          forcedisable = true;
        }
      }

      return forcedisable || !this.payment.documents_available;
    },
    isOpenOrder() {
      this.$store.showTax = false;
      return AppConstant.OrderType.OPEN === this.payment.order.order_type;
    },
    billAmount() {
      return Number(this.payment.total);
    },
  },
};
</script>

<style lang="scss" scoped>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.invoice-payment-actions {
  width: calc(100% - 960px);
  text-align: right;
  .action{
    display: inline-block;
    padding:0 5px;
  }
}
.invoice-consignee {
  &-label {
    padding-bottom: 10px;
    &:first-child {
      padding-top: 10px;
    }
  }
  &-name {
    color: #404040;
    font-size: 12px;
  }
  &-lr {
    font-family:$fontSemibold;
  }
}
.physical-copy-container {
  padding-top: 10px;
      height: 90px;
  //padding-bottom: 5px;
  span {
    display: inline-block;
    //padding-left: 5px;
    color: #404040;
    font-size: 14px;
    font-family:$fontSemibold;
    line-height: 17px;
  }
}
.lrnumber-pending {
  color: #A12D2D;
}
.rowdisabled {
  .row-text {
    opacity: 0.5;
  }
}
.inlineblock_attachment{
    display: inline-block;
    vertical-align: middle;
    .paddingspan{
      padding-left: 10px;
    }
}
.popover-auto{
    width: auto;
    .popfooter  {
    background: #f8f8f8;
    margin-left: -20px;
    margin-bottom: -20px;
    margin-right: -20px;
    padding: 8px 20px;
    color: #404040;
    font-size: 12px;
    font-weight: 600;
    margin-top: 15px;
    span{
      padding-left: 8px;
    }
    }
    .lrnumber_list{
      font-size: 13px;
      ul{
        padding: 0px;
        margin: 5px 0;
        li{
          display: inline-block;
          border-right:1px solid #404040;
          line-height: 10px;
          padding-right: 4px;
          &:last-child{
            border-right: 1px solid transparent;
          }
        }
      }
    }
}
</style>
